<div
  class="label-container {{ type }}"
  [class.disabled]="isEditingMode || !isHoverable"
  [ngbTooltip]="shouldDisplayTooltip ? fullNameTooltip : null"
  [keepOnHover]="true"
  [placement]="'top bottom'"
  [tooltipClass]="'default-tooltip'"
>
  @if (icon && showIcons && !isEditingMode) {
    <svg-icon class="w-3 h-3" [src]="icon"></svg-icon>
  }

  <ng-container *ngTemplateOutlet="isTemplatePassed ? labelTemplate : truncatedLabel"></ng-container>

  @if (showIcons && isEditingMode) {
    <button data-test-id="remove-label" class="remove-label {{ type }}" (click)="removeLabel.emit()">
      <svg-icon class="p-0.5" [src]="'close-thin'"></svg-icon>
    </button>
  }
</div>

<ng-template #fullNameTooltip>
  <ng-container *ngTemplateOutlet="isTemplatePassed ? labelTemplate : labelText"></ng-container>
</ng-template>

<ng-template #labelText>
  <span>{{ name }}</span>
</ng-template>

<ng-template #truncatedLabel>
  <span #label class="truncate">{{ name }}</span>
</ng-template>
